import React from 'react'
import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button'

export const ArquivoImportacaoDialog = ({
                                          visible,
                                          onHide,
                                          onCancel,
                                          onFileSelect,
                                          title = 'Selecionar arquivo importação',
                                          fileType = 'CSV',
                                          acceptType = 'UTF-8',
                                        }) => {
  const footer = (
    <div>
      <Button
        label={'Cancelar'}
        onClick={onCancel}
        className="p-button-danger"
        style={{ marginTop: '20px' }}
      />
    </div>
  )

  return (
    <Dialog
      header={title}
      visible={visible}
      style={{ width: '15vw' }}
      onHide={onHide}
      baseZIndex={1000000}
      modal={true}
      closable={true}
      footer={footer}
    >
      <div style={{ paddingTop: '20px' }}>
        <label className="label-btn-arquivo-retorno" htmlFor="selecao-arquivo-csv">
          {`Clique para selecionar o arquivo - ${fileType}`}
        </label>
        <input
          id="selecao-arquivo-csv"
          type="file"
          onChange={onFileSelect}
          accept={acceptType}
        />
      </div>
    </Dialog>
  )
}